import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "./auth.service";

@Injectable()
export class AuthGuard implements CanActivate {
  succesfullLogin: boolean = false;

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot){
    return this.getNavigate();
  }

  getNavigate() {
    if (!this.authService.valid() && localStorage.getItem('token') == null) {
      this.router.navigateByUrl('');
        return this.succesfullLogin;
    }
    this.succesfullLogin = true;
    return this.succesfullLogin;
}
}
